var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5A4.5 4.5 0 0 0 7.5 6v6a4.5 4.5 0 1 0 9 0V6A4.5 4.5 0 0 0 12 1.5ZM15 12V6a3 3 0 1 0-6 0v6a3 3 0 1 0 6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.463A7.501 7.501 0 0 1 4.5 12v-1.5a.75.75 0 0 1 1.5 0V12a6 6 0 0 0 12 0v-1.5a.75.75 0 0 1 1.5 0V12a7.501 7.501 0 0 1-6.75 7.463v2.287a.75.75 0 0 1-1.5 0v-2.287Z"
  })));
};

export default SvgMic;